<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="dialog"
      width="500"
    >

      <v-card>
        <div style="text-align: center;">
          <h1 style="padding: 30px 15px; font-weight: 300; padding-bottom: 15px;">Thank you! You have successfully placed your order.</h1>
          <v-icon style="color: #E51515; font-size: 50px; padding-bottom: 15px;">mdi-check</v-icon>
          <div style="padding-bottom: 7.5px; padding-right: 7.5px; padding-left: 7.5px;">
            <v-btn depressed color="primary" style="font-weight: 400; text-transform: capitalize !important; width: 100%; margin: 0;">View My Purchases</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>
<style lang="scss">

</style>
<script>
export default 
{
    props: {
      show: {
        type: Boolean,
        default: false
      }
    },
    data () {
        return {
          dialog: false
        }
    },

    mounted () {

    },
    methods : {

    },
    watch : {
      show : {
          handler: function (after, before) {
              this.dialog = after
          },
          deep: true,
      }
    }
}
</script>